import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_CHAIN_COMPONENT, REMOVE_ALL_CHAIN_COMPONENTS, CHAIN_LOADED, REMOVE_CHAIN_ENTRY } from './chain-actions.js'

export const chainReducer = entriesReducerFactory(
  SET_CHAIN_COMPONENT,
  REMOVE_ALL_CHAIN_COMPONENTS,
  REMOVE_CHAIN_ENTRY,
  CHAIN_LOADED,
)
